import { c as _c } from "react/compiler-runtime";
import { Badge } from '@sbt-web/ui';
import commonClasses from '../common/styles.module.scss';
const NewBadge = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Badge themed={true} classes={[commonClasses["novelty-badge"]]}>Novità</Badge>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export { NewBadge };